'use client';

import type { TDynamicData } from '../../types/dynamic-data';

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@eliadmin/core/src/components/ui/tabs';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useState } from 'react';
import { HtmlDescription } from '../shared/html-description';

export const DesktopTabExplanation = ({
  explanations,
  colors,
}: {
  explanations: TDynamicData[];
  colors: {
    trigger: 'white' | 'foreground' | 'primary';
    content: 'white' | 'foreground';
  };
}) => {
  const [activeTab, setActiveTab] = useState<string>(explanations[0].name);
  const filterTab = (tabName: string) =>
    explanations.find(explanation => explanation.name === tabName);

  return (
    <Tabs
      onValueChange={value => setActiveTab(value)}
      defaultValue={activeTab}
      className={cn(
        'explanations__tabs',
        'custom-container',
        'hidden w-full items-start justify-between gap-12 md:flex',
      )}
    >
      <TabsList
        className={cn(
          'explanations__tabs-list',
          'flex h-fit w-full max-w-[705px] flex-col items-start justify-start gap-4 bg-transparent p-0',
        )}
      >
        {explanations.map(explanation => (
          <TabsTrigger
            key={explanation.name}
            value={explanation.name}
            className={cn(
              'explanations__tabs-trigger',
              `explanations__tabs-trigger--${colors.trigger}`,
              'flex h-fit w-full items-center justify-between bg-transparent p-0 text-left text-3xl font-bold lg:text-4xl',
            )}
          >
            {explanation.name}
          </TabsTrigger>
        ))}
      </TabsList>
      <TabsContent
        value={activeTab}
        className={cn('explanations__tabs-content', 'w-full max-w-[705px]')}
      >
        <HtmlDescription
          color={colors.content}
          content={filterTab(activeTab)?.fields[0]?.value ?? ''}
          size="lg"
          className="w-full max-w-[705px]"
        />
      </TabsContent>
    </Tabs>
  );
};
